import * as angular from "angular";''
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.attachments')
  .service('attachmentsAPI', AttachmentsAPI);

function AttachmentsAPI(): BringozApi {
  return {
    base: `/attachments`,
    infiniteScroll: {
      address: `/attachments`,
      cmd: 'GET'
    },
    actions: {
      getUrl: {
        address: '',
        cmd: 'GET',
        updateable: true
      }
    }
  }
}
